import React, { createContext, useContext } from 'react';
import { Link } from 'gatsby';

// Hver side bygges to ganger (se gatsby-node.js): norsk på vanlig sti, engelsk under /en.
export const LanguageContext = createContext({ lang: 'no', path: '/' });

export const useLang = () => useContext(LanguageContext).lang;

// Bruk: const t = useT(); t('Norsk tekst', 'English text')
export const useT = () => {
  const lang = useLang();
  return (no, en) => (lang === 'en' ? en : no);
};

export const stripLangPrefix = (path) => path.replace(/^\/en(?=\/|$)/, '') || '/';

export const localizePath = (path, lang) => (lang === 'en' ? `/en${path}` : path);

export const LocalizedLink = ({ to, ...props }) => {
  const lang = useLang();
  return <Link to={localizePath(to, lang)} {...props} />;
};

export const LanguageSwitch = ({ className = '' }) => {
  const { lang, path, translated } = useContext(LanguageContext);
  if (!translated) {
    return null;
  }
  const basePath = stripLangPrefix(path);
  const isEnglish = lang === 'en';
  return <Link
    to={isEnglish ? basePath : localizePath(basePath, 'en')}
    hrefLang={isEnglish ? 'no' : 'en'}
    lang={isEnglish ? 'no' : 'en'}
    className={className}
  >
    {isEnglish ? 'Norsk' : 'English'}
  </Link>
};
